import { useTranslation } from "react-i18next";
import { FiClipboard } from "react-icons/fi";
import { EventDataDto, PublicContextDto } from "../../../autogen/bff-api";
import { momentLocaleFor } from "../../../common/formatting/i18nFormatters";
import {
  formatContractDuration,
  formatEstimatedValue,
} from "../../sourcing-events/portal/utils/displayFormatters";
import { LabelValueGrid } from "../../sourcing-events/portal/view-single/LabelValueGrid";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";

const DASH = "–";

export const ContractSection = ({
  eventData,
  publicContext,
}: {
  eventData: EventDataDto;
  publicContext: PublicContextDto;
}) => {
  const { t, i18n } = useTranslation();
  const duration = eventData.contractDuration;
  const value = publicContext.estimatedValue;

  return (
    <SectionCard icon={FiClipboard} title={t("Contract")}>
      <LabelValueGrid
        rows={[
          {
            label: t("Estimated value"),
            value: value?.value != null ? formatEstimatedValue(value.value, value.currency) : DASH,
          },
          {
            label: t("Contract duration"),
            value: duration ? formatContractDuration(duration, t, momentLocaleFor(i18n.language)) : DASH,
          },
        ]}
      />
    </SectionCard>
  );
};
